/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveOfferResponse
 */
export interface ApproveOfferResponse {
    /**
     * 
     * @type {number}
     * @memberof ApproveOfferResponse
     */
    offerId: number;
}

/**
 * Check if a given object implements the ApproveOfferResponse interface.
 */
export function instanceOfApproveOfferResponse(value: object): value is ApproveOfferResponse {
    if (!('offerId' in value) || value['offerId'] === undefined) return false;
    return true;
}

export function ApproveOfferResponseFromJSON(json: any): ApproveOfferResponse {
    return ApproveOfferResponseFromJSONTyped(json, false);
}

export function ApproveOfferResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveOfferResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'offerId': json['offerId'],
    };
}

export function ApproveOfferResponseToJSON(json: any): ApproveOfferResponse {
    return ApproveOfferResponseToJSONTyped(json, false);
}

export function ApproveOfferResponseToJSONTyped(value?: ApproveOfferResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offerId': value['offerId'],
    };
}

